export var PlayerStatusType;
(function (PlayerStatusType) {
    PlayerStatusType[PlayerStatusType["NORMAL"] = 1] = "NORMAL";
    PlayerStatusType[PlayerStatusType["SUSPENDED"] = 2] = "SUSPENDED";
    PlayerStatusType[PlayerStatusType["NO_CARD"] = 4] = "NO_CARD";
})(PlayerStatusType || (PlayerStatusType = {}));
//# sourceMappingURL=PlayerStatusType.js.map